export enum VetspireModalType {
    Notes = "Notes",
    Recap = "Recap",
}

export interface VetspireRecapOptions {
    vaccines: boolean;
    medications: boolean;
    allergies: boolean;
    problems: boolean;
    notes: boolean;
    lab_results: boolean;
    vitals: boolean;
    treatments: boolean;
    diagnostics: boolean;
    clinical_notes: boolean;
    encounters: boolean;
}

export const defaultVetspireRecapOptions: VetspireRecapOptions = {
    vaccines: true,
    medications: true,
    allergies: true,
    problems: true,
    notes: true,
    lab_results: true,
    vitals: true,
    treatments: true,
    diagnostics: true,
    clinical_notes: true,
    encounters: true,
};